import axiosInstance from "./axios";

export class NoticiaService {
    getNoticiasAll() {
        return axiosInstance
            .get(`/noticia`)
            .then((res) => res.data)
    }

    addNoticia(dto) {
        return axiosInstance
            .post(`/noticia`, dto)
            .then((res) => res.data)
    }

    updateNoticia(dto) {
        return axiosInstance
            .put(`/noticia/${dto._id}`, dto)
            .then((res) => res.data)
    }

    deleteNoticia(id) {
        return axiosInstance
            .delete(`/noticia/${id}`)
            .then((res) => res.data)
    }
}
